export const getFeedDetailMediaSizingClassName = ({
  aspectRatio,
  shouldUseNativeVideo,
}: {
  aspectRatio: number | null;
  shouldUseNativeVideo: boolean;
}) => {
  if (shouldUseNativeVideo || !aspectRatio) return 'h-full w-full';

  if (aspectRatio < 1) return 'h-full w-auto md:h-[50vh]';
  if (aspectRatio === 1) return 'max-h-[60vh] w-full md:max-h-none';

  return 'max-h-full w-full max-w-full';
};

/**
 * 决定原生 <video> 的 onerror 事件是否应该上抛给外层错误占位。
 *
 * 部分 WebView（尤其是微信 / X5 内核）在 loop 边界重新 seek（一遍播完跳回 0）
 * 时会触发一次 spurious 'error' 事件，但 videoElement.error 实际为 null。
 * 如果此时仍然把错误上抛，外层会调用 setIsError(true) 把整个视频区切到
 * 「视频加载失败」占位，看起来像循环失败、其实是误报。
 *
 * 仅当浏览器真的填充了 MediaError 才视为真错误。
 */
export const shouldEmitNativeVideoError = (mediaError: MediaError | null | undefined): mediaError is MediaError =>
  Boolean(mediaError);
